module.exports = __webpack_public_path__ + "static/media/icon_video_whisper_disabled.acf8b78c.svg";